import { createReducer } from "@ec-oem/ec.oem.oa3.ui.core/utility";
import { fromJS } from "immutable";
import { SET_HOSTS } from "../actions";

export const hosts = createReducer(null, {
	[SET_HOSTS](state, { hosts }) {
		return fromJS(hosts);
	}
});
